import { createFileRoute } from '@tanstack/react-router';
import ConfirmResetPasswordPage from '../pages/ConfirmResetPasswordPage';

export const Route = createFileRoute('/reset-password/confirm')({
  component: ConfirmResetPasswordPage,
});
